import React, { useState } from "react"
import { TextArea} from "devextreme-react";
import { useDispatch, useSelector } from "react-redux";
import { sendFactoryComment } from "../../../redux/currentCase/thunks";
import { FormActionButtons } from "./FormActionButtons";
import { InputWrapper } from "./InputWrapper";
import { validateAddFactoryCommentData } from "../case/formValidationFunctions";
import { openModal } from "../../../redux/modal/modalSlice";
import { errorHandler } from "../../../commonFunctions/errorHandler";
import { getCommentByCaseId } from "../../../redux/contract/thunks";
import { getFactoryCasesByPlate } from "../../../redux/factoryCases/thunks";
import { selectContract } from "../../../redux/contract/selectors";
import { selectCurrentCase } from "../../../redux/currentCase/selectors";

function AddFactoryCommentForm(props){
    const {showAddFactoryCommentForm, handleShowForms, setShowAddFactoryCommentForm, formClassName, currentCaseId = null, processId, expedient} = props;
    const [disabledActionButtons, setDisabledActionButtons] = useState(false)
    const dispatch = useDispatch();
    const contract = useSelector(selectContract);
    const caseLoadedInPanel = useSelector(selectCurrentCase)

    const [formData, setFormData] = useState({
        comment: "",
    })

    async function handleSubmit(){
        const submitData = {...formData, processId: processId, expedient: expedient}
        setDisabledActionButtons(true);
        if(!validateAddFactoryCommentData(submitData, dispatch)){
            setDisabledActionButtons(false);
            return
        }

        try {

            await dispatch(sendFactoryComment({body: submitData}))
            
            const refreshCaseComments = currentCaseId || (caseLoadedInPanel.factoryProcessId === processId) // si el caso cargado en el panel tiene asignado el caso en fábrica que estamos comentando, refrescar vista de comentarios del caso

            if(refreshCaseComments){
                await dispatch(getCommentByCaseId({query: `?caseId=${caseLoadedInPanel.caseId}`}))
            }
            
            await dispatch(getFactoryCasesByPlate({query: `?plate=${contract.plate}`}))

            setFormData(
                {
                    comment: "",
                }
            )
        } catch (error) {
            dispatch(openModal(errorHandler(error)))
        } 
        finally{
            setDisabledActionButtons(false);
            setShowAddFactoryCommentForm(false)
        }
    }

    return(
        <div className={`case-header-form  ${formClassName || ""}`} style={showAddFactoryCommentForm ?{display: "block"}: {display:"none"}}>
            <InputWrapper label="Comentario fábrica" labelColor={"#3B5158"}>
                <TextArea height={150} value={formData.comment} onValueChanged={(e)=>setFormData(prevState=>({...prevState, comment: e.value}))}/>
            </InputWrapper>
            <FormActionButtons
                cancelFunction={()=>handleShowForms("addFactoryComment")}
                submitFunction={handleSubmit}
                submitText={"Añadir comentario fábrica"}
                disabled={disabledActionButtons}
            />
        </div>
    )
}

export {AddFactoryCommentForm}